import type { RouteRecordRaw } from 'vue-router'

export const UiKitRoute: RouteRecordRaw = {
  name: 'UiKitView',
  path: '/service/ui-kit',
  component: () => import('../ui/UiKitView.vue'),
  meta: {
    layout: 'emptyLayout'
  }
}
